import { UserActionsTypeChipField } from 'pages/UserActions/components/UserActionTypeChipField/UserActionTypeChipField';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Chip } from 'shared/mui/Chips';
import { Stack } from 'shared/mui/Stack/Stack';
import { DateTimeChipField, FunctionField } from 'shared/react-admin/Fields';
import { ReferenceField } from 'shared/react-admin/ReferenceFields';
import { UserAction } from 'types/embedded/userAction';

export const UserActionsShowChipFields = () => {
  const translate = useTypedTranslate();

  return (
    <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
      <FunctionField
        render={(record: UserAction) => <Chip label={`ID: ${record?.originId}`} size="small" />}
      />
      <DateTimeChipField label={translate('app.table.lastUpdatedAt')} source="createdAt" />
      <ReferenceField reference="user_event_types" source="eventType">
        <UserActionsTypeChipField source="description" />
      </ReferenceField>
    </Stack>
  );
};
